import { Box, Typography, Button, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * "¿Eres tú?" al postular (PLAN_IMPORTACION_COMPUTRABAJO, fase 0).
 *
 * El proceso de la vacante ya tiene una ficha con el correo de la cuenta (ya
 * verificado con el código del portal) y sin RUT (POST /applications
 * respondió CONFIRM_APPLICANT). Se muestra el nombre registrado y la persona
 * responde: sí → postula con esa ficha; no → postula igual y un reclutador
 * revisará sus datos. onAnswer('yes' | 'no') reintenta la postulación.
 */
const PortalApplicantConfirm = ({ applicantName, onAnswer, onCancel, disabled = false }) => {
  const { t } = useTranslation();

  return (
    <Paper elevation={0} sx={{ border: '1px solid #E5E7EB', borderRadius: 2, p: 3, mb: 3 }}>
      <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
        {t('portal.identity.confirmApplicantTitle')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {t('portal.identity.confirmApplicantText', { name: applicantName || '—' })}
      </Typography>
      <Button
        variant="contained"
        fullWidth
        onClick={() => onAnswer('yes')}
        disabled={disabled}
        sx={{ backgroundColor: '#6A5AF9', '&:hover': { backgroundColor: '#5B4DE8' }, py: 1.5, mb: 1 }}
      >
        {t('portal.identity.confirmApplicantYes')}
      </Button>
      <Button
        variant="outlined"
        fullWidth
        onClick={() => onAnswer('no')}
        disabled={disabled}
        sx={{ py: 1.25 }}
      >
        {t('portal.identity.confirmApplicantNo')}
      </Button>
      <Box sx={{ mt: 1 }}>
        <Button fullWidth size="small" color="inherit" onClick={onCancel} disabled={disabled}>
          {t('portal.back')}
        </Button>
      </Box>
    </Paper>
  );
};

export default PortalApplicantConfirm;
